export default [
  {
    path: "/custom-video",
    name: "custom-video",
    component: () =>
      import("@/views/admin/custom-video/CustomVideo.vue"),
  },
];
